var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"ladda",class:_vm.buttonClass,attrs:{"data-style":_vm.dataStyle,"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._t("default",function(){return [_c('span',{staticClass:"ladda-label"},[_vm._v("Submit")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }